module.exports = __webpack_public_path__ + "img/cloud-icon.7d31adcd.svg";